import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const MeterpointGuide = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/meterpoint-guide/components/MeterpointGuideContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/meterpoint-guide/components/MeterpointGuideHeader'
      )
  )
};

export default MeterpointGuide;
